import Header from '../components/Header';
import BlogDetail from '../components/BlogDetail';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const BlogDetailPage = () => {
  return (
    <>
      <Header />
      <div style={{marginTop: '64px'}}>
        <BlogDetail />
      </div>
      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default BlogDetailPage;
